export interface IImageDimensions {
	width: number;
	height: number;
}

export class ImageHelper {
	calculateAspectRatioFit(
		originalDimensions: IImageDimensions | undefined,
		maxWidthOrHeight: number
	): IImageDimensions {
		if (!originalDimensions) {
			return {
				height: maxWidthOrHeight,
				width: maxWidthOrHeight
			};
		}
		const ratio = Math.min(maxWidthOrHeight / originalDimensions.width, maxWidthOrHeight / originalDimensions.height);

		return { width: originalDimensions.width * ratio, height: originalDimensions.height * ratio };
	}

	getDimensionsForMaxHeight(originalDimensions: IImageDimensions, maxHeight: number): IImageDimensions {
		if (originalDimensions.height <= maxHeight) {
			return originalDimensions;
		}

		const ratio = maxHeight / originalDimensions.height;

		return {
			height: maxHeight,
			width: ratio * originalDimensions.width
		};
	}

	getDimensionsForMaxWidth(originalDimensions: IImageDimensions, maxWidth: number): IImageDimensions {
		if (originalDimensions.width <= maxWidth) {
			return originalDimensions;
		}

		const ratio = maxWidth / originalDimensions.width;

		return {
			height: ratio * originalDimensions.height,
			width: maxWidth
		};
	}
}

export const imageHelper = new ImageHelper();
